import { priceReducer } from "../reducer/PriceReducer";

export const reducer = priceReducer;
